import React, {
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { Link } from "react-router-dom";
import { getPolicyList } from "./policyService";
import TosterService from "../../../Services/Toster-Service/TosterService";
import { LoaderContext } from "../../../Services/Loader_Provider_Service/LoadingContext";
import { InputText } from "primereact/inputtext";
import { debounce } from "lodash";
const ComponentLoader = React.lazy(() =>
  import("../../../Shared/Sidebar/ComponentLoader")
);
const Policylist = () => {
  const [policyList, setpolicyList] = useState([]);
  const toster = useRef(null);
  const [Isloading, setIsloading] = useState(false);
  const [systemAlert, setSystemAlert] = useState([]);
  const [createPolicyePermission, setCreatePolicyePermission] = useState(false);
  const publishedPolicies = policyList.filter((policy) => policy.IsPublished);
  const draftPolicies = policyList.filter((policy) => !policy.IsPublished);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");
  const [noData, setNoData] = useState([]);

  useEffect(() => {
    getPolicyListData("Policy_Name", 1);
    permissionPolicy();
    GetMasterSystemAlertList();
    GetMasterSystemAlertList("No_Policies", 2);
  }, []);

  async function getPolicyListData() {
    setIsloading(true);
    const param = {
      OrgId: userDetails?.OrgId,
      CategoryId: 0,
      IsPublished: 0,
      GUID: "",
      pagenumber: 1,
      pagesize: 100,
    };
    try {
      let projectDetailData = await getPolicyList(param);
      setpolicyList(projectDetailData?.Data?.policyList);
      setIsloading(false);
    } catch {
      setIsloading(false);
    }
  }
  const permissionPolicy = () => {
    const hasCreatePermission = userPermissions.some(
      (permission) => permission.PermissionName === "Policy.Create"
    );

    if (hasCreatePermission) {
      setCreatePolicyePermission(true);
    }
  };

  let SearchValue = "";
  const handleInputChange = (event) => {
    debouncedSearch(event.target.value);
  };

  const debouncedSearch = useCallback(
    debounce((value) => {
      SearchValue = value;
      let filteredList = policyList?.filter((item) =>
        item?.PolicyName?.toLowerCase()?.includes(SearchValue?.toLowerCase())
      );
      if (SearchValue != "") {
        setpolicyList(filteredList);
      } else {
        getPolicyListData();
      }
    }, 800),
    [policyList]
  );

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 1) {
        setSystemAlert(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setNoData(msg?.Desc);
      }
    });
  }, []);

  // const truncatedHTML = (policy) => {
  //   return policy.ShortDesc.length > 100
  //     ? policy.ShortDesc.substring(0, 100)
  //     : policy.ShortDesc;
  // };

  function truncatedHTML(html, maxLength = 100) {
    const div = document.createElement("div");
    div.innerHTML = html;
    const text = div.textContent || "";

    if (text.length <= maxLength) return text;

    return text.slice(0, maxLength) + "...";
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-xl-12">
          <div className="form-head d-flex flex-wrap align-items-center mb-4">
            <div className="me-auto">
              <h2 className="font-w600 mb-0">Organization Policies</h2>
            </div>
            <div className="rightside-tabs">
              <div className="input-group search-area2 d-xl-inline-flex me-2">
                <button className="input-group-text">
                  <i className="fa fa-search text-primary"></i>
                </button>
                <InputText
                  name="requestTitle"
                  className="form-control"
                  onChange={handleInputChange}
                  placeholder="Search"
                />
              </div>
              {createPolicyePermission && (
                <Link to="/AddPolicy">
                  <button className="add-newpolicy" title="Add">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-plus"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                    </svg>
                    New Policy
                  </button>
                </Link>
              )}
            </div>
          </div>
        </div>
        <div className="col-xl-12">
          <div className="row">
            <div className="col-xl-8">
              <div className="policytab">
                <div className="row g-3">
                  <div className="policy-category-title">
                    <h5>{systemAlert}</h5>
                  </div>
                  {publishedPolicies.map((policy) => {
                    return (
                      <div className="col-12">
                        {/* <Link to={`/AddPolicy`}> */}
                        <Link to={`/Policy/Detail/${policy?.GUID}`}>
                          <div className="pol-div">
                            <img src="/images/org-img/policy/policydefault.png" />
                            <div className="policy-detailtext">
                              <h3>{policy?.PolicyName}</h3>

                              <p
                                dangerouslySetInnerHTML={{
                                  __html: truncatedHTML(policy.ShortDesc),
                                }}
                              />
                            </div>
                            <div className="policy-actions">
                              <a href="" className="view-policy">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-chevron-right"
                                  viewBox="0 0 16 16"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
                                  />
                                </svg>
                              </a>
                            </div>
                          </div>
                        </Link>
                      </div>
                    );
                  })}
                </div>
              </div>
              {!Isloading && publishedPolicies.length === 0 && (
                <div className="notfound">
                  <img src="/images/no-data-found/No_Policy.png" />
                  <p>{noData}</p>
                </div>
              )}
            </div>

            {draftPolicies.length > 0 && createPolicyePermission && (
              <div className="col-xl-4">
                <div className="draft-policy-list">
                  <h4>Draft Policies</h4>
                  <div className="list">
                    {draftPolicies.map((policy) => {
                      return (
                        <div className="li-list">
                          <img
                            src="https://cdn-icons-png.flaticon.com/128/11206/11206081.png"
                            className="w-100"
                          />
                          <div className="media-body px-0">
                            <h6 className="mt-0 mb-0 fss-14">
                              {policy?.PolicyName}
                            </h6>
                            {/* <p>{policy?.ShortDesc}</p> */}

                            <p
                              dangerouslySetInnerHTML={{
                                __html: truncatedHTML(policy.ShortDesc),
                              }}
                            />
                          </div>
                          {createPolicyePermission && (
                            <Link
                              to={`/EditPolicy/${policy?.GUID}`}
                              className="common-status-color"
                            >
                              View
                            </Link>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <TosterService ref={toster} />
      {Isloading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
};

export default Policylist;
